import { get } from '../http/api';





export default get( '/layers/serviceobjects' ).mapsurfer().sealed()
	.map( layer => layer.id )
	.chain( ids => get( `/geocoding?layersId=${ids}&query={query}&bbox={bbox}` ).mapsurfer() )
	.peek( ({ items, layerId }) => items.forEach( it => it.layerId = layerId ) )
	.map( ({ items }) => items )
	.concat()
	.map( ({ pkid, layerId, label, point }) => ({ objectId: pkid, layerId, title: label, coords: point }) )


// WEBPACK FOOTER //
// ./src/js/collection/service.objects.js